import { useCallback, useEffect, useState } from 'react';
import type { PaymentCondition } from '../pages/DashboardPage/views/FinancesView/masters/financeMasters';
import { listPaymentConditions } from '../services/PaymentConditionsService';

// Condiciones de pago de la sociedad activa, desde la API (payment_conditions_list)
export const usePaymentConditions = () => {
  const [conditions, setConditions] = useState<PaymentCondition[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const reload = useCallback(async (force = false) => {
    setLoading(true);
    try {
      setConditions(await listPaymentConditions({ force }));
      setError('');
    } catch (err) {
      console.error('Error cargando las condiciones de pago:', err);
      setError((err as Error)?.message || 'No se pudieron cargar las condiciones de pago.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    let active = true;
    listPaymentConditions()
      .then(list => { if (active) { setConditions(list); setError(''); } })
      .catch(err => {
        console.error('Error cargando las condiciones de pago:', err);
        if (active) setError((err as Error)?.message || 'No se pudieron cargar las condiciones de pago.');
      })
      .then(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);

  return { conditions, loading, error, reload };
};
